export default __webpack_public_path__ + "static/media/ksm.a733d54b.svg";